import { RecurlyAccount } from '../../types/types'

import CardInfoComponent from './CardInfoComponent'
interface propTypes {
  account: RecurlyAccount
}

export default function CurrentPaymentInfoComponent(props: propTypes) {
  const { account } = props
  const billingInfo = account.billingInfo
  return (
    <div className="d-flex">
      {billingInfo ? (
        <CardInfoComponent billingInfo={billingInfo} />
      ) : (
        <div className="alert alert-warning mb-0">
          <strong>No payment option added.</strong> Add a payment method to
          continue subscribing.
        </div>
      )}
    </div>
  )
}
